export const pre_defined_questions = [
  "What is the purpose of UTahData.org?",
  "What kind of information does UTahData.org provide?",
  "Can you describe the content and scope of UTahData.org?",
  "How frequently is Utah data updated on UTahData.org?",
  "What dashboards are available for real-time Utah data monitoring?",
  "What is the current population of Utah?",
  "How many counties are there in the state of Utah?",
  "Which county in Utah has the highest population?",
  "How many charter schools operate in Utah?",
  "Which Utah county has the highest percentage of college graduates?",
  "What is the median age of residents in Utah?",
  "Which Utah counties are growing the fastest?",
  "What is the current unemployment rate in Utah?",
  "What is the count of cities in Salt lake County?",
  "How many hospitals are there in Utah?",
  "What is the gender ratio in Utah?",
  "How many active voters are there in Utah?",
  "What is the property tax rate in Utah?",
  "What percentage of Utah’s workforce holds a bachelor’s degree or higher?",
  "What is the state income tax rate in Utah?",
  "How many bookmobiles are there in utah?",
  "What are the three main types of electric vehicle (EV) charging levels available in Utah?",
  "What is the average household size in Utah?",
  "How can I access detailed Utah county-level data?",
  "Which state surround Utah by largest land area?",
  "Which counties have the highest employment growth?",
  "Which county has good AQI in Utah?",
  "How many registered voters are there in Utah?",
  "Name a significant historical mining operation in Utah.",
  "Which Olympic venue in Utah allows visitors to skate on 'the fastest ice on Earth'?",
  "Name a popular ski resort in Utah.",
  "Which national park in Utah is known for having more than 2,000 natural arches?",
  "Which team plays ice hockey in Utah?",
  "Where is the majority of Utah's gross state product produced?",
  "What is the base rate of state sales tax in Utah?",
  "What minerals are commonly mined in Utah?",
  "Name five national parks located in Utah.",
  "What is the name of the well-known salt flat in Utah, famous for land speed records?",
  "Name a technical college located in Utah.",
  "Which Utah National Park is known for its deep canyons carved by the Colorado River and Green River?",
  "Which city in Utah is known for its ski resorts and for hosting Olympic events?",
  "Which institute at Utah State University is dedicated to disability research?",
  "Which university in Utah has centers like the Center for Aging and Center for Human Toxicology?",
  "Which University of Utah engineering research center focuses on prototyping and advanced education?",
  "How many public library locations are there in Utah?",
  "What types of libraries, besides public, are listed in the Utah Library Directory?",
  "What is the approximate population of Utah County?",
  "What major U.S. Air Force base is a major employer in Davis County?",
  "What is the name of the hospital in Provo under the Intermountain Health system?",
  "Name at least three MLM companies headquartered in Utah.",
  "Which city in Utah has a high concentration of MLM companies?",
  "Which federal agency is the largest Department of Defense employer in Utah?",
  "What is the primary mission of Hill Air Force Base?",
  "Which agency manages national parks and monuments in Utah?",
  "Which agency is responsible for tax administration in Utah?",
  "What services does the U.S. Department of Veterans Affairs provide in Utah?",
  "Which agency manages Utah's natural resources like soil and water?",
  "Which Major League Soccer (MLS) team is based in Utah?",
  "What is the name of Utah's professional ice hockey team?",
  "Name the major NCAA Division I athletic program in Salt Lake City.",
  "What is the name of Utah's Triple-A Minor League Baseball team?",
  "What is the ZIP code range in Utah?",
  "How many school districts are there in Utah?",
  "How has the unemployment rate changed in Utah over 10 years?",
  "How many incorporated cities are there in Utah?",
  "What is the high school dropout rate in Utah?",
  "Which metro area in Utah has the second-fastest growth in the U.S.?",
  "When was Utah’s historical low unemployment rate and what was it?",
  "What was the county employment growth rate in January 2025?",
  "What demographic categories are shown in Utah’s 'At a Glance'?",
  "What industries are featured in UtahData verticals?",
  "How is UTahData.org described on its About page?",
  "What is the manufacturing sector’s role in Utah’s economy?",
  "What percent of Utah’s population lives in the Wasatch Front?",
  "How many SBA 8(a) companies are there in Utah?",
  "How many educational attainment categories are shown on UtahData?",
  "What are the major industry supersectors defined on UTahData.org?",
  "Which Utah cities have the highest migration rates?",
  "What was Utah’s median single-family home price around 2022–2023?",
  "Which school district has the most schools?",
  "Which county has Alpine School District?",
  "How many students are enrolled in Alpine Online School?",
  "How many schools are in Beaver School District?",
  "What is the annual population growth of Utah?",
  "Which district has the fewest schools?",
  "Which districts appear to have only primary or elementary level schools?",
  "How many DC charging stations are there in utah?",
  "Which county has highest literacy rate in utah?",
  "How many airports are there in Utah?",
  "What city/state is airport code UT24 located in?",
  "Which Utah airports are heliports?",
  "In which city is STRAWBERRY VALLEY ESTATES airport?",
  "How many airports are in Alton, Utah?",
  "Which is Utah’s most populous county?",
  "What are the top 3 university research focus areas in Utah?",
  "What is University of Utah’s research contribution statewide?",
  "What are Utah State University’s research strengths?",
  "Which institutions excel in environmental science research?",
  "What is the land area of St. George city?",
  "How many public universities are in Utah?",
  "Which national park is most visited in utah?",
  "Which is the largest MLM company by revenue in Utah?",
  "Which Utah metro areas are fast-growing?",
  "Which city is the MLM hub of Utah?",
  "How many copper mines are there in Utah?",
  "Which mines are in Carbon County?",
  "Which Utah mines are surface vs. underground?",
  "What mining operations are in Uintah Basin?",
  "How many coal mines are in Utah?",
  "How many mines in Utah produce gold?",
  "Which Utah hospital has the most beds?",
  "How many Intermountain Healthcare hospitals are there?",
  "How many hospitals are classified under 'Community' in Utah?",
  "In which city is Huntsman Cancer Institute?",
  "How many hospitals are in Ogden City?",
  "How many financial institutions operate in Utah?",
  "Which city has the most financial institutions?",
  "What types of financial institutions are listed in Utah?",
  "How many credit unions exist in Utah?",
  "Which institution has the most branches in Utah?",
  "How many state parks are in Utah?",
  "What are the five largest ethnic groups in Utah?",
  "What percentage of Utahns are Latter-day Saints?",
  "What are Utah’s biggest revenue sources?",
  "How many Utah residents live urban vs. rural?",
  "What is the median home price in Salt Lake County?",
  "How many EV charging stations are in Utah?",
  "How many EV chargers are in Salt Lake City?",
  "What is Utah’s current housing vacancy rate?",
  "What is the student-teacher ratio in Utah?",
  "What is Utah’s poverty rate?",
  "What is the minimum wage in Utah?",
  "How many people in Utah are self-employed?",
  "What are the top occupations in Utah?",
  "What is Utah’s labor force participation rate?",
  "What is the average life expectancy in Utah?",
  "How many people lack health insurance in Utah?",
  "What is Utah’s birth rate?",
  "What are the main pollution sources in Utah?",
  "Which Utah cities are most populated?",
  "What is the population of Salt Lake City?",
  "Which county has the largest land area in Utah?",
  "Which counties in Utah are rural?",
  "Which Utah county has the most school districts?",
  "How many Utah counties border other states?",
  "Which hospitals are trauma centers in Utah?",
  "How many Utah hospitals are public vs. private?",
  "Which Utah county has the most mines?",
  "What is the total area of Utah in square miles?",
  "How many geothermal power plants operate in Utah?",
  "Name two research areas of Huntsman Mental Health Institute.",
  "What is Utah’s foreign-born population?",
  "What is meant by the 'Mighty 5' parks of Utah?",
  "What is Utah’s rank for Economic Dynamism?",
  "Which industry recently led Utah’s GDP?",
  "What three geological regions converge in Utah?",
  "Which counties have highest and lowest unemployment rates?",
  "What is the unemployment rate by age group in Utah?",
  "What percentage of Utah’s population lives in urban versus rural areas?",
  "Which airport has the longest runway in Utah?",
  "What type of airport is AMERICAN FORK HOSPITAL?",
  "Which is the least populated Utah county?",
  "What is Davis County’s per capita income?",
  "Which Utah city has the most EV charging stations?",
  "How many students are in higher education in Utah?",
  "Which counties lack EV charging stations?",
  "How many Tesla Supercharging stations are in Utah?",
  "How many major research institutions exist in Utah?",
  "Which institutions are collaborating on AI-related research in Utah?",
  "How many public colleges in Utah offer associate degrees?",
  "How many community colleges are in Utah?",
  "What are the top 5 minerals mined in Utah?",
  "How many parks in Utah offer camping facilities?",
  "How many congressional districts does Utah have?",
  "Which congressional district includes Hill AFB?",
  "How many starter homes did Gov. Cox propose?",
  "Which Utah cities serve as major hubs for financial and tech industries?",
  "What percent of Utah’s population is Hispanic or Latino?",
  "How many electric vehicles are registered in Utah?",
  "What is the median household income in Utah?",
];
